import ArrowForwardIcon from '../../assets/icons/arrow_forward.svg?react';
import XLink from '../common/XLink';

const arrowClasses =
    'ml-auto h-action-arrow-h w-action-arrow-w flex-none';

const visibilityClasses = {
    hidden: 'opacity-0 invisible',
    visible: 'opacity-100 visible',
};

const CaseSummaryLink = ({ caseId, text = "Overview", hideOnInit = true, onClick }) => (
    <XLink
        to={`/case/summary/${caseId}`}
        variant="actionOutline"
        className={`view-btn ${hideOnInit ? visibilityClasses.hidden : visibilityClasses.visible}`}
        onClick={onClick}
    >
        <span>{text}</span>
        <ArrowForwardIcon className={arrowClasses} />
    </XLink>
);

export default CaseSummaryLink;
